import React from 'react';
import { FormattedMessage } from 'react-intl';

const propertiesSortByOptions = [
    {
        type    : 'item',
        content : <FormattedMessage id="bf.recommended" defaultMessage="bf.recommended" />,
        value   : 'recommended',
    },
    {
        type    : 'item',
        content : <FormattedMessage id="bf.price" defaultMessage="bf.price" />,
        value   : 'price',
    },
    {
        type    : 'item',
        content : <FormattedMessage id="bf.rating" defaultMessage="bf.rating" />,
        value   : 'rating',
    },
    {
        type    : 'item',
        content : <FormattedMessage id="bf.name" defaultMessage="bf.name" />,
        value   : 'name',
    },
];
export default propertiesSortByOptions;
